import React, { useState, useEffect } from 'react';
import { Box, TextField, AppBar, Tab, Tabs } from '@material-ui/core';
import {
  notifyInfo,
  notifyError,
  notifyWarning,
} from '../../components/Messages/Notification';
import AutoCompleteAccountNo from '../../components/AutoComplete/AutoCompleteAccountNo';
import { getPreviousDate } from '../../services/ProfileService';
import Button from '../../components/Buttons/Button';

import QueryParam from '../../services/QueryParamService';
import useStyles from '../../styles';
import ClientSummaryAccountSetupFields from './Components/ClientSummaryAccountSetupFields';
import ClientSummaryBalanceFields from './Components/ClientSummaryBalanceFields';
import ClientSummaryPositionTable from './Components/ClientSummaryPositionTable';
import ClientSummaryMarginRequirementFields from './Components/ClientSummaryMarginRequirementFields';
import ClientSummarySegregationFields from './Components/ClientSummarySegregationFields';
import ClientSummaryNonTradeTable from './Components/ClientSummaryNonTradeTable';
import ClientSummaryTradeTable from './Components/ClientSummaryTradeTable';
import PropTypes from 'prop-types';
import { listClientSummary } from '../../services/ClientSummaryService';
import { dateProtoObjectToString } from '../../services/ConvertService';
import Text from '../../components/Typography/Text';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

export default function ClientSummaryTab({ params }) {
  const classes = useStyles();
  //Set value of system date search parameter
  useEffect(
    () => {
      async function init() {
        if (searchData.date) return;

        const previousDate = await getPreviousDate();
        setSearchData({
          ...searchData,
          date: previousDate,
        });
      }

      init();
    },
    // eslint-disable-next-line
    []
  );
  const [accountSetupData, setAccountSetupData] = React.useState({});
  const [balanceData, setBalanceData] = React.useState({});
  const [marginReqData, setMarginReqData] = React.useState({});
  const [segregationData, setSegregationData] = React.useState({});
  const [tabValue, setTabValue] = React.useState(0);
  const [positionRows, setPositionRows] = useState([]);
  const [nonTradeRows, setNonTradeRows] = useState([]);
  const [tradeRows, setTradeRows] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(true);
  const [isCashMarginType, setIsCashMarginType] = React.useState(false);
  //search parameters initial value
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      date: '',
      accountNo: '',
    })
  );

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSearch = async () => {
    if (!searchData.date) {
      notifyWarning('Date is Required');
      return;
    }
    if (searchData.accountNo === '') {
      notifyWarning('Account No is Required');
      return;
    }

    try {
      setLoading(true);
      QueryParam.set(searchData);
      const data = await listClientSummary(searchData);
      let valid = 0;

      if (data.balance.msg !== '') {
        //notifyWarning(data.balance.msg)
      } else {
        data.balance.tradeDate = dateProtoObjectToString(data.balance.tradeDate);

        valid = 1;
      }

      if (data.balance.marginType !== 'Cash') {
        if (data.marginRequirement.msg !== '') {
          //notifyWarning(data.marginRequirement.msg)
        } else {
          data.marginRequirement.tradeDate = dateProtoObjectToString(
            data.marginRequirement.tradeDate
          );
          data.marginRequirement.date = searchData.date;
          valid = 1;
        }

        if (data.segregation.msg !== '') {
          //notifyWarning(data.segregation.msg)
        } else {
          data.segregation.settleDate = dateProtoObjectToString(
            data.segregation.settleDate
          );
          data.segregation.date = searchData.date;
          valid = 1;
        }

        setIsCashMarginType(false);
      } else {
        setIsCashMarginType(true);
      }

      if (data.positionsList.length === 0) {
        //notifyWarning("No Position Records")
      } else {
        valid = 1;
      }

      if (data.nonTradesList.length === 0) {
        //notifyWarning("No Non-Trades Records")
      } else {
        valid = 1;
      }

      if (data.tradesList.length === 0) {
        //notifyWarning("No Trades Records")
      } else {
        valid = 1;
      }
      if (!data.accountSetup) {
        //notifyWarning("No Trades Records")
      } else {
        valid = 1;
      }

      setBalanceData(data.balance);
      setMarginReqData(data.marginRequirement);
      setSegregationData(data.segregation);
      setPositionRows(data.positionsList);
      setNonTradeRows(data.nonTradesList);
      setTradeRows(data.tradesList);
      setAccountSetupData(data.accountSetup);

      if (valid) {
        notifyInfo('Client Summary Results Loaded');
      } else {
        notifyWarning('No Client Summary Results Found');
      }
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({
      ...searchData,
      [input.name]: input.value,
    });
  };

  return (
    <div className={classes.root} style={{ padding: 30 }}>
      <Box component="div">
        <div>
          <div className={classes.grdRow}>
            <div className={classes.grdCell1}>
              <Text mt={8} variant="h1" label="Client Summary" />
            </div>
          </div>
          <div className={classes.grdRow}>
            <div className={classes.grdCell1} style={{ marginRight: 30 }}>
              <TextField
                name="date"
                fullWidth
                label="Date"
                type="date"
                value={searchData.date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                required={true}
              />
            </div>
            <div className={classes.grdCell1} style={{ marginRight: 30 }}>
              <div className="grd-cell">
                <AutoCompleteAccountNo
                  name="accountNo"
                  value={searchData.accountNo}
                  onChange={handleChange}
                  required={true}
                  type="Client"
                />
              </div>
            </div>
            <div className={classes.grdCell1} style={{ marginRight: 30 }}></div>
            <div className={classes.grdCell1}></div>
          </div>
          <div className={classes.grdRow}>
            <div className={classes.grdCellNone}>
              <Button
                disabled={loading}
                loading={loading}
                type="search"
                label={loading ? 'Searching...' : 'Search'}
                onClick={handleSearch}
              />
            </div>
          </div>
        </div>
      </Box>
      <Box component="div" mt={2}>
        <AppBar
          position="static"
          className={classes.tabHeader}
          style={{
            backgroundColor: '#ffffff',
            boxShadow: 'none',
            borderBottom: '1px solid #e8e8e8',
            borderTop: '1px solid #e8e8e8',
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="auto"
            variant="fullWidth"
            centered
          >
            <Tab label="Balance" {...a11yProps(0)} />
            <Tab label="Position" {...a11yProps(1)} />
            <Tab
              label="Margin Requirement"
              {...a11yProps(2)}
              disabled={isCashMarginType}
            />
            <Tab label="Segregation" {...a11yProps(3)} disabled={isCashMarginType} />
            <Tab label="Non-Trade" {...a11yProps(4)} />
            <Tab label="Trade" {...a11yProps(5)} />
            <Tab label="Account Setup" {...a11yProps(6)} />
          </Tabs>
        </AppBar>
        <TabPanel value={tabValue} index={0} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummaryBalanceFields value={balanceData} />
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={1} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummaryPositionTable value={positionRows} />
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={2} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummaryMarginRequirementFields value={marginReqData} />
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={3} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummarySegregationFields value={segregationData} />
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={4} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummaryNonTradeTable value={nonTradeRows} />
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={5} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummaryTradeTable value={tradeRows} />
          </Box>
        </TabPanel>
        <TabPanel value={tabValue} index={6} style={{ backgroundColor: '#ffffff' }}>
          <Box mt={2}>
            <ClientSummaryAccountSetupFields value={accountSetupData} />
          </Box>
        </TabPanel>
      </Box>
    </div>
  );
}
